var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-header" },
          [
            _c(
              "b-button",
              {
                attrs: { size: "sm", variant: "primary" },
                on: { click: _vm.addMigracao }
              },
              [_vm._v("Adicionar Migração")]
            ),
            _vm._v(" "),
            _vm.perfil == "adm" || _vm.perfil == "coord_comercial"
              ? _c(
                  "b-button",
                  {
                    staticClass: "ml-3",
                    attrs: {
                      size: "sm",
                      variant: "success",
                      href: "/adm/migracao/liberacao"
                    }
                  },
                  [_vm._v("Liberar Migração")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-12 mt-3" },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              items: _vm.dataComputed,
              fields: _vm.colunas
            },
            scopedSlots: _vm._u([
              {
                key: "cell(actions)",
                fn: function(row) {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: { size: "sm", variant: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.show(row.item.id)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-eye" })]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Migração de classe", size: "lg" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: { click: _vm.salvaMigracao }
                    },
                    [
                      _c("i", { staticClass: "fas fa-list-ol" }),
                      _vm._v(" Migrar\n                ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary", size: "sm" },
                      on: { click: _vm.limpaForm }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.openedModal,
            callback: function($$v) {
              _vm.openedModal = $$v
            },
            expression: "openedModal"
          }
        },
        [
          _c("div", { staticClass: "card" }, [
            _c(
              "ul",
              { staticClass: "text-danger" },
              _vm._l(_vm.errors, function(error) {
                return _c("li", { key: error }, [_vm._v(_vm._s(error))])
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "radio-inline" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.migrar_todos,
                        expression: "migrar_todos"
                      }
                    ],
                    staticClass: "radio-inline",
                    attrs: { type: "radio" },
                    domProps: {
                      value: true,
                      checked: _vm._q(_vm.migrar_todos, true)
                    },
                    on: {
                      change: function($event) {
                        _vm.migrar_todos = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v(" Migrar Todas Revendedoras")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.migrar_todos,
                        expression: "migrar_todos"
                      }
                    ],
                    staticClass: "radio-inline",
                    attrs: { type: "radio" },
                    domProps: {
                      value: false,
                      checked: _vm._q(_vm.migrar_todos, false)
                    },
                    on: {
                      change: function($event) {
                        _vm.migrar_todos = false
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v(" Migrar Somente uma Revendedora")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("label", [
                      _vm._v(
                        "Selecione o Distribuidor de origem, pelo qual terá a(s) revendedoras\n                            transferidas."
                      )
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        options: _vm.ObjListaDistribuidor,
                        disabled: !_vm.migrar_todos,
                        onSearch: _vm.getDistribuidor
                      },
                      model: {
                        value: _vm.origem,
                        callback: function($$v) {
                          _vm.origem = $$v
                        },
                        expression: "origem"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.migrar_todos,
                      expression: "!migrar_todos"
                    }
                  ],
                  staticClass: "row"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("label", { staticClass: "text-info" }, [
                        _vm._v(" Selecione a Revendedora a ser migrada.")
                      ]),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          options: _vm.ObjListaRevendedora,
                          onSearch: _vm.getRevendedoras,
                          placeholder: "Digite o CPF da revendedora"
                        },
                        on: { input: _vm.selectRevenda },
                        model: {
                          value: _vm.revendedoras,
                          callback: function($$v) {
                            _vm.revendedoras = $$v
                          },
                          expression: "revendedoras"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("label", [
                      _vm._v(
                        "Distribuidor Destino. Distribuidor que irá receber as novas revendedoras."
                      )
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        options: _vm.ObjListaDistribuidor,
                        disabled: false,
                        onSearch: _vm.getDistribuidor
                      },
                      model: {
                        value: _vm.destino,
                        callback: function($$v) {
                          _vm.destino = $$v
                        },
                        expression: "destino"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Relatório de Migração de Classe G",
            size: "xl",
            scrollable: ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.openedReport = false
                        }
                      }
                    },
                    [_vm._v("Fechar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.openedReport,
            callback: function($$v) {
              _vm.openedReport = $$v
            },
            expression: "openedReport"
          }
        },
        [
          _c("table", { staticClass: "table table-hover" }, [
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v("Nome")]),
                _vm._v(" "),
                _c("th", [_vm._v("Cadastro")]),
                _vm._v(" "),
                _c("th", [_vm._v("Endereco ")])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.listaRevendedora, function(list, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(list.revendedora))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(list.cadastro))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(list.endereco))])
                ])
              }),
              0
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a8bb8cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a8bb8cc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_migracao/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7a8bb8cc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_migracao/List.vue
// module chunks = 2